export default function getStartAndEndOfDay(start: string, end: string) {
    try {
        const startD = new Date(start);
        const endD = new Date(end);

        // Lấy đầu ngày (00:00:00)
        const startOfDay = new Date(startD);
        startOfDay.setHours(0, 0, 0, 0);

        // Lấy cuối ngày (23:59:59.999)
        const endOfDay = new Date(endD);
        endOfDay.setHours(23, 59, 59, 999);

        return {
            startOfDay: startOfDay.toISOString(),
            endOfDay: endOfDay.toISOString(),
        };
    } catch (err) {
        // console.log("🚀 ~ getStartAndEndOfDay ~ err:", err);
        return {
            startOfDay: "",
            endOfDay: "",
        };
    }
}
